export default "__VITE_ASSET__CPtigJ4___"